import { TID } from "@/constants/testIds";

export function AICoachSection({ aiText, aiLoading, aiError, onRequestAi }) {
  return (
    <section className="relative ai-glow border border-[#2E2A25] bg-[#0F0E0C] p-5 rounded-sm">
      <div className="relative z-10 flex items-baseline justify-between mb-3">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#CFA66A]">
            &mdash; AI Coach
          </p>
          <h3 className="font-head text-lg text-[#EBE5D9] mt-1">
            Claude trade review
          </h3>
        </div>
        <button
          data-testid={TID.aiReviewBtn}
          onClick={onRequestAi}
          disabled={aiLoading}
          className="bg-[#CFA66A] text-[#0F0E0C] font-medium px-4 py-2 text-sm rounded-sm hover:bg-[#EBE5D9] transition-colors disabled:opacity-50"
        >
          {aiLoading ? "Analyzing..." : aiText ? "Regenerate" : "Get feedback"}
        </button>
      </div>
      {aiError && (
        <p className="relative z-10 text-[#B56258] text-sm font-mono">{aiError}</p>
      )}
      {aiText ? (
        <div
          data-testid={TID.aiReviewText}
          className="relative z-10 text-sm text-[#EBE5D9] leading-relaxed whitespace-pre-wrap"
        >
          {aiText}
        </div>
      ) : (
        <p className="relative z-10 text-sm text-[#A39A8E] italic">
          Fill in your reflection above, then request a review. Claude will give you
          personalized coaching on this session.
        </p>
      )}
    </section>
  );
}
